/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class AuditApiService {
  constructor(private api: CustomerApiService) {}

  newsAudit(data: any): Observable<any> {
    return this.api.post('/v1/news_audits/start', data);
  }

  newsDismiss(data: any): Observable<any> {
    return this.api.post('/v1/news_audits/dismiss', data);
  }

  newsResolve(data: any): Observable<any> {
    return this.api.post('/v1/news_audits/resolve', data);
  }

  getAuditedCases(data: any): Observable<any> {
    return this.api.post('/v1/news_audits', data);
  }

  getDismissedCases(data: any): Observable<any> {
    return this.api.post('/v1/news_audits/dismissed', data);
  }

  getAuditedIds(): Observable<any> {
    return this.api.get('/v1/news_audits/articles');
  }

  getDismissedIds(): Observable<any> {
    return this.api.get('/v1/news_audits/dismissed/articles');
  }

  getAuditedSubjects(): Observable<any> {
    return this.api.get('/v1/news_audits/subjects');
  }

  getDismissedSubjects(): Observable<any> {
    return this.api.get('/v1/news_audits/dismissed/subjects');
  }
}
